<template>
  <div>
     <div class="kit__utils__heading">
       <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
     </div>
     <div class="card">
       <div class="card-header card-header-flex">
         <div class="d-flex flex-column justify-content-center mr-auto">
           <h5 class="mb-0"></h5>
         </div>
         <div class="d-flex flex-column justify-content-center">
           <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่ม errorCode</a>&nbsp;
         </div>
       </div>
       <div class="card-body">
         <div class="card-header card-header-flex">
           <div class="d-flex flex-column justify-content-center mr-auto">
             <h5 class="mb-0"></h5>
           </div>
           <div class="d-flex flex-column justify-content-center">
             <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                 class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
           </div>
         </div>
         <a-table :columns="columns" :dataSource="data" rowKey='id' :scroll="{ x: 1200 }">
             <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              size="small"
              style="width: 90px; margin-right: 8px"
            >Search</a-button>
            <a-button
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
            >Reset</a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
           <span slot="Action" slot-scope="text,record">
             <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item @click="showModal('update',record.id)">แก้ไข errorCode </a-menu-item>
              </a-menu>
            <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
          </a-dropdown>
           </span>
         </a-table>
       </div>
     </div>
     <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
       @cancel="handleCancel">
       <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
         <div class="row">
           <div class="col-md-12">
             <a-form-model-item label="service">
                <a-select v-model="form.serviceId">
                 <a-select-option value="">
                   กรุณาเลือกข้อมูล
                 </a-select-option>
                 <a-select-option v-for="(item , index) in apiList" :key="index" :value="item.id">
                   {{ item.name }}
                 </a-select-option>
               </a-select>
             </a-form-model-item>
           </div>
           <div class="col-md-12">
             <a-form-model-item label="code" prop="code">
               <a-input v-model="form.code" />
             </a-form-model-item>
           </div>
           <div class="col-md-12">
             <a-form-model-item label="en" prop="en">
               <a-input v-model="form.en" />
             </a-form-model-item>
           </div>
           <div class="col-md-12">
             <a-form-model-item label="th" prop="th">
               <a-input v-model="form.th" />
             </a-form-model-item>
           </div>
           <div class="col-md-12">
             <a-form-model-item label="description">
               <a-input v-model="form.description" />
             </a-form-model-item>
           </div>
         </div>
       </a-form-model>
     </a-modal>
  </div>
</template>

<script>

// import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
// import moment from 'moment'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      data: [],
      dataService: [],
      apiList: [],
      columns: [
        {
          title: 'ลำดับ',
          key: 'id',
          dataIndex: 'id',
          width: 120,
        },
        {
          title: 'Service',
          key: 'name',
          dataIndex: 'name',
          filters: [],
          onFilter: (value, record) => record.name.toString().includes(value.toString()),
        },
        {
          title: 'Code',
          key: 'code',
          dataIndex: 'code',
          sorter: (a, b) => a.code - b.code,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'code',
          },
          onFilter: (value, record) => record.code.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'en',
          key: 'en',
          dataIndex: 'en',
        },
        {
          title: 'th',
          key: 'th',
          dataIndex: 'th',
        },
        {
          title: 'description',
          key: 'description',
          dataIndex: 'description',
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'operatorId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      visible: false,
      form: {
        id: '',
        code: '',
        en: '',
        th: '',
        serviceId: '',
        description: '',
      },
      rules: {
        code: [
          { required: true, message: 'กรุณากรอก code', trigger: 'blur' },
        ],
        en: [
          { required: true, message: 'กรุณากรอก en', trigger: 'blur' },
          { min: 2, max: 50, message: 'ความยาวตัวอักษรควรเป็น 2 ถึง 50', trigger: 'blur' },
        ],
        th: [
          { required: true, message: 'กรุณากรอก th', trigger: 'blur' },
          { min: 2, max: 50, message: 'ความยาวตัวอักษรควรเป็น 2 ถึง 50', trigger: 'blur' },
        ],
        // service: [{ required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' }],
      },
    }
  },
  methods: {
    clearForm() {
      this.form = {
        id: '',
        code: '',
        en: '',
        th: '',
        serviceId: '',
        description: '',
      }
    },
    showModal(type, id = null) {
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มข้อมูล errorCode' : 'แก้ไขข้อมูล errorCode'

      if (type === 'update') {
        this.getDataErrorCode(id)
      } else {
        this.visible = !this.visible
      }
    },

    getDataErrorCode(id) {
      apiClient.get(`/errorCode/${id}`).then(res => {
        if (res.data.code === '000') {
          const data = res.data.responseData.data[0]
          this.form.id = data.id
          this.form.serviceId = data.serviceId
          this.form.code = data.code
          this.form.en = data.en
          this.form.th = data.th
          this.form.description = data.description
          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async getData() {
      await apiClient.get('/errorCode/getData').then(response => {
        if (response.data.code === '000') {
          this.data = response.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
           `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },

    async getDataServie() {
      await apiClient.get('/errorCode/getApiService').then(response => {
        if (response.data.code === '000') {
          this.dataService = response.data.responseData.data
          this.apiList = []
          this.apiList = this.dataService
          if (this.dataService.length > 0) {
            const listOperater = this.dataService.map(function(item, pos) {
              return { text: item.name, value: item.name }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
           `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },

    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // ส่งข้อมูลอัปเดทสถานะ
                // console.log(this.form);
                if (this.form.type === 'update') {
                  return apiClient.put(`errorCode/update/${this.form.id}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                        `เกิดข้อผิดพลาด: ${error.message}`,
                    )
                  })
                } else {
                  // console.log(this.form);
                  return apiClient.post('errorCode/createNew', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                        `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.confirmLoading = false
              this.getData()
            }
          })
        }
      })
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },

    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },

    refreshData() {
      this.loading(true)
      this.getData()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    await this.getData()
    await this.getDataServie()
  },

}
</script>

<style>

</style>
